// Weekly asset yield — called at SettleWeek for every owned asset.
// Each asset pays its weeklyYield to wallet as a passive-income txn.

import type { GameState } from '../state/types.js';
import { applyTxn } from '../ledger/append.js';

export function settleAssetYields(state: GameState): GameState {
  let s = state;
  for (const asset of state.assets) {
    if (asset.weeklyYield <= 0) continue;
    s = applyTxn(s, {
      type: 'asset_yield',
      amount: asset.weeklyYield,
      category: 'passive',
      note: `Yield from ${asset.defId}`,
    });
  }
  // Increment weeksOwned on all assets (separate pass — keeps the txn loop clean).
  s = {
    ...s,
    assets: s.assets.map((a) => ({ ...a, weeksOwned: a.weeksOwned + 1 })),
  };
  return s;
}
